'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from "prop-types";
import "./loading.scss";
/*
https://signalvnoise.com/posts/2577-loading-spinner-animation-using-css-and-webkit
https://www.andreaverlicchi.eu/blog/css-3-only-spinning-loading-animation/
*/
/* ========== MARKDOWN ========== */
/**
 * Loading — provides a spinner/loading indicator used across the UI.
 *
 * This component renders a CSS spinner; use `ToggleLoading` to control visibility programmatically.
 */
/** Loading.propTypes — No props (component renders a CSS spinner).
 * @param {any} [props] - No props are accepted by Loading.
 */
Loading.propTypes = { /** no props */};
export function Loading(props) {
    return (_jsx(_Fragment, { children: _jsx("div", { id: "loadingSpinner", className: "loading", children: _jsxs("div", { className: "spinner", children: [_jsx("div", { className: "bar1" }), _jsx("div", { className: "bar2" }), _jsx("div", { className: "bar3" }), _jsx("div", { className: "bar4" }), _jsx("div", { className: "bar5" }), _jsx("div", { className: "bar6" }), _jsx("div", { className: "bar7" }), _jsx("div", { className: "bar8" }), _jsx("div", { className: "bar9" }), _jsx("div", { className: "bar10" }), _jsx("div", { className: "bar11" }), _jsx("div", { className: "bar12" })] }) }) }));
}
ToggleLoading.propTypes = {
    /** When true shows the global loading spinner; false hides it; omitted toggles the current state. */
    show: PropTypes.bool,
};
export function ToggleLoading(props) {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return;
    const loadingElem = document.getElementById("loadingSpinner");
    if (!loadingElem)
        return;
    if (props.show === true) {
        loadingElem.style.display = "inline-block";
    }
    else if (props.show === false) {
        loadingElem.style.display = "none";
    }
    else {
        // Toggle behavior
        if (loadingElem.style.display === "none" || !loadingElem.style.display) {
            loadingElem.style.display = "inline-block";
        }
        else {
            loadingElem.style.display = "none";
        }
    }
}
